'use client';
import { FontWeightToStyles } from '../../util/font.js';

var TagColor;
(function (TagColor) {
    TagColor["TRANSPARENT"] = "TRANSPARENT";
    TagColor["GRAY"] = "GRAY";
    TagColor["PRIMARY"] = "PRIMARY";
    TagColor["ORANGE"] = "ORANGE";
    TagColor["BLUE"] = "BLUE";
    TagColor["RED"] = "RED";
    TagColor["PURPLE"] = "PURPLE";
})(TagColor || (TagColor = {}));
var TagSize;
(function (TagSize) {
    TagSize["XS"] = "XS";
    TagSize["SMALL"] = "SMALL";
    TagSize["LARGE"] = "LARGE";
})(TagSize || (TagSize = {}));
var TagRounding;
(function (TagRounding) {
    TagRounding["FULL"] = "FULL";
    TagRounding["SM"] = "SM";
})(TagRounding || (TagRounding = {}));
const TagColorToStyles = {
    [TagColor.TRANSPARENT]: (hoverable) => `border border-leland-gray-stroke ${hoverable ? 'hover:opacity-50' : ''}`,
    // add border the same color as bg for the following so there is no pixel difference between them and TRANSPARENT
    [TagColor.GRAY]: (hoverable) => `bg-leland-gray-hover text-leland-gray-light border border-leland-gray-hover ${hoverable ? 'hover:bg-leland-gray-stroke' : ''}`,
    [TagColor.PRIMARY]: (hoverable) => `bg-leland-primary-extra-light text-leland-dark-green border border-leland-primary-extra-light ${hoverable ? 'hover:bg-leland-primary-light' : ''}`,
    [TagColor.ORANGE]: (hoverable) => `bg-leland-orange-light text-leland-orange border border-leland-orange-light ${hoverable ? 'hover:bg-leland-orange-light-hover' : ''}`,
    [TagColor.BLUE]: (hoverable) => `bg-leland-blue-light text-leland-blue border border-leland-blue-light ${hoverable ? 'hover:bg-leland-blue-light-hover' : ''}`,
    [TagColor.RED]: (hoverable) => `bg-leland-red-light text-leland-red border border-leland-red-light ${hoverable ? 'hover:bg-leland-red-light-hover' : ''}`,
    [TagColor.PURPLE]: (hoverable) => `bg-leland-purple text-leland-white border border-leland-purple ${hoverable ? 'hover:bg-leland-purple-hover' : ''}`,
};
const getTagSizeStyles = (tagSize, { decreasedYPadding, decreasedLeftPadding, decreasedRightPadding, }) => {
    switch (tagSize) {
        case TagSize.XS:
            return `text-sm leading-4 space-x-1.5 py-1 ${decreasedLeftPadding ? 'pl-1' : 'pl-2'} ${decreasedRightPadding ? 'pr-1' : 'pr-2'}`;
        case TagSize.SMALL:
            return `text-sm space-x-2 py-1.5 ${decreasedLeftPadding ? 'pl-1.5' : 'pl-2.5'} ${decreasedRightPadding ? 'pr-1.5' : 'pr-2.5'}`;
        case TagSize.LARGE:
            return `text-base leading-tight space-x-2 ${decreasedYPadding ? 'py-1.5' : 'py-2'} ${decreasedLeftPadding ? 'pl-1.5' : 'pl-3'} ${decreasedRightPadding ? 'pr-1.5' : 'pr-3'}`;
    }
};
const TagRoundingToStyles = {
    [TagRounding.FULL]: 'rounded-full',
    [TagRounding.SM]: 'rounded',
};
const getTagSizeIconStyles = (tagSize, largeIcons) => {
    switch (tagSize) {
        case TagSize.XS:
            return largeIcons ? 'size-4.5' : 'size-3.5';
        case TagSize.SMALL:
            return largeIcons ? 'size-5' : 'size-4';
        case TagSize.LARGE:
            return largeIcons ? 'size-6' : 'size-4';
    }
};
const getTagStyles = ({ tagColor, size, fontWeight, rounding, hoverable, ...tagSizePaddingProps }) => `${TagColorToStyles[tagColor](hoverable)} ${getTagSizeStyles(size, tagSizePaddingProps)} ${FontWeightToStyles[fontWeight]} ${TagRoundingToStyles[rounding]}`;

export { TagColor, TagRounding, TagSize, getTagSizeIconStyles, getTagStyles };
//# sourceMappingURL=constants.js.map
